import {createFileRoute, useNavigate} from "@tanstack/react-router"
import {TileSpread} from "../../../components/Tile.tsx";
import {useCallback} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRightLong} from "@fortawesome/pro-regular-svg-icons";
import {ShinwaJobTile, ShinwaJobTileProps} from "../../../job/tile.tsx";
import {useExportableJobs, useExportedJobs} from "../../../rpc/webrpc-client.gen.ts";
import {keyify} from "../../../util/arutil.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";

function ExportJobTile(props: ShinwaJobTileProps) {
    const {jobId, ...rest} = props;
    const navigate = useNavigate();
    const perform = useCallback(() => navigate({
        to: "/export/job/$id",
        params: {id: jobId},
    }), [navigate, jobId]);
    const actionProps = keyify([{
        color: "primary", variant: "solid",
        perform,
        children: <FontAwesomeIcon icon={faArrowRightLong}/>
    } as const]);

    return <ShinwaJobTile jobId={jobId} actionProps={actionProps} {...rest}/>;
}

// function JobExportPage() {
//     const mama = useMothership();
//     const tqrv = useRefreshableInfallibleQuery(watchExportableJobsTqo(mama));
//
//     if (!tqrv.isSuccess) {
//         return <SuspenseDialog message="fetching jobs"/>;
//     }
//
//     const jobStubs = tqrv.data;
//
//     return <PageShell>
//         <PageHeader><TopBar/></PageHeader>
//         <PageBody>
//             <TileSpread estimatedHeight={80} foods={jobStubs}
//                         Component={({food: stub}) =>
//                             <ExportJobTile jobId={stub.id} key={stub.id}/>}/>
//         </PageBody>
//     </PageShell>
// }

function JobExportPage() {
    const availableTqrv = useExportableJobs();
    const doneTqrv = useExportedJobs();

    const tileFoods = [
        ...(availableTqrv.data ?? []).map(stub => ({stub, flavor: "exportable"})),
        ...(doneTqrv.data ?? []).map(stub => ({stub, flavor: "exported"})),
    ];

    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <TileSpread estimatedHeight={120} foods={tileFoods}
                        Component={({food: {stub, flavor}}) => {
                            if (flavor === "exportable") {
                                return <ExportJobTile jobId={stub.id} key={stub.id}/>
                            } else {
                                return <ShinwaJobTile jobId={stub.id} color="success" variant="outlined"
                                                      sx={{borderStyle: "dashed"}}/>
                            }
                        }}/>
        </PageBody>
    </PageShell>
}

export const Route = createFileRoute("/_auth/admin/job-export")({
    component: JobExportPage
});
